module.exports = __webpack_public_path__ + "static/media/pepperono.08688889.jpg";